export const GradeCode = {
  KG1: "kg1",
  KG2: "kg2",
  G1: "grade1",
  G2: "grade2",
  G3: "grade3",
  G4: "grade4",
  G5: "grade5",
  G6: "grade6",
  G7: "grade7",
  G8: "grade8",
  G9: "grade9",
  G10: "grade10",
  G11: "grade11",
  G12: "grade12",
};
